import axios from "axios";
import { getApiBaseUrl } from "../config/api";

const API = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use(
  (config) => {
    config.baseURL = getApiBaseUrl();
    return config;
  },
  (error) => Promise.reject(error),
);

// Send OTP
export const sendOtpApi = (mobileNumber) => {
  return API.post("/auth", {
    mobileNumber,
  });
};

// Verify OTP
export const verifyOtpApi = ({
  mobileNumber,
  otp,
  device_type,
  device_token,
}) => {
  return API.post("/verify", {
    mobileNumber,
    otp,
    device_type,
    device_token,
  });
};
